import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subscription-expired-modal',
  templateUrl: './subscription-expired-modal.component.html',
  styleUrls: ['./subscription-expired-modal.component.css']
})
export class SubscriptionExpiredModalComponent {
  @Input() expiresAt: string | null = null;
  @Input() daysUntilExpiry: number | null = null;

  constructor(public activeModal: NgbActiveModal, private router: Router) {}

  get formattedDate(): string {
    if (!this.expiresAt) return '';
    var d = new Date(this.expiresAt);
    if (isNaN(d.getTime())) return this.expiresAt;
    var dd = ('0' + d.getDate()).slice(-2);
    var mm = ('0' + (d.getMonth() + 1)).slice(-2);
    var yyyy = d.getFullYear();
    return dd + '/' + mm + '/' + yyyy;
  }

  renovar(): void {
    this.activeModal.close('renovar');
    this.router.navigate(['/pago']);
  }

  cerrar(): void {
    this.activeModal.dismiss('cerrar');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/subscription-expired-modal/subscription-expired-modal.component.ts